import React from 'react';
import { Box, Typography, Card, CardContent, Grid, Fade } from '@mui/material';
import { 
  AccountBalance as BalanceIcon,
  CreditCard as CreditIcon
} from '@mui/icons-material';

const BilleteraHeader = ({ balance, credit_limit }) => {
  const formatCurrency = (amount) => {
    return amount !== undefined ? Number(amount).toFixed(2) : '0.00';
  };

  return (
    <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ mb: { xs: 3, sm: 4 } }}>
      {/* Saldo Actual Card */}
      <Grid item xs={12} sm={6}>
        <Fade in={true} timeout={800}>
          <Card
            sx={{
              borderRadius: { xs: 2, sm: 3 },
              background: 'linear-gradient(135deg, #002642 0%, #00577A 100%)',
              boxShadow: { xs: 2, sm: 4 },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: { xs: 'none', sm: 'translateY(-4px)' },
                boxShadow: { xs: 3, sm: 8 }
              },
              overflow: 'hidden',
              position: 'relative',
              minHeight: { xs: 120, sm: 160 }
            }}
          >
            {/* Decorative elements */}
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                zIndex: 1
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: -30,
                left: -30,
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.05)',
                zIndex: 1
              }}
            />
            
            <CardContent sx={{ 
              p: { xs: 2, sm: 3 },
              position: 'relative',
              zIndex: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, sm: 2 } }}>
                <Box
                  sx={{
                    p: { xs: 0.75, sm: 1 },
                    borderRadius: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    mr: { xs: 1.5, sm: 2 }
                  }}
                >
                  <BalanceIcon sx={{ 
                    color: '#FFFFFF', 
                    fontSize: { xs: '1.25rem', sm: '1.5rem' } 
                  }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: '#FFFFFF',
                    fontWeight: 600,
                    fontSize: { xs: '0.9rem', sm: '1.1rem' },
                    opacity: 0.9
                  }}
                >
                  Saldo Actual
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#FFFFFF',
                    fontWeight: 700,
                    fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },
                    lineHeight: 1,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    mb: { xs: 0.5, sm: 0.5 }
                  }}
                >
                  ${formatCurrency(balance)}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }}
                >
                  Disponible para usar
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Fade>
      </Grid>

      {/* Límite de Crédito Card */}
      <Grid item xs={12} sm={6}>
        <Fade in={true} timeout={1000}>
          <Card
            sx={{
              borderRadius: { xs: 2, sm: 3 },
              background: 'linear-gradient(135deg, #DB9600 0%, #F4B942 100%)',
              boxShadow: { xs: 2, sm: 4 },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: { xs: 'none', sm: 'translateY(-4px)' },
                boxShadow: { xs: 3, sm: 8 }
              },
              overflow: 'hidden',
              position: 'relative',
              minHeight: { xs: 120, sm: 160 }
            }}
          >
            {/* Decorative elements */}
            <Box
              sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.1)',
                zIndex: 1
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: -30,
                left: -30,
                width: 100,
                height: 100,
                borderRadius: '50%',
                background: 'rgba(255, 255, 255, 0.05)',
                zIndex: 1
              }}
            />
            
            <CardContent sx={{ 
              p: { xs: 2, sm: 3 },
              position: 'relative',
              zIndex: 2,
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: { xs: 1, sm: 2 } }}>
                <Box
                  sx={{
                    p: { xs: 0.75, sm: 1 },
                    borderRadius: 2,
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    mr: { xs: 1.5, sm: 2 }
                  }}
                >
                  <CreditIcon sx={{ 
                    color: '#FFFFFF', 
                    fontSize: { xs: '1.25rem', sm: '1.5rem' } 
                  }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: '#FFFFFF',
                    fontWeight: 600,
                    fontSize: { xs: '0.9rem', sm: '1.1rem' },
                    opacity: 0.9
                  }}
                >
                  Límite de Crédito
                </Typography>
              </Box>
              <Box>
                <Typography
                  variant="h3"
                  sx={{
                    color: '#FFFFFF',
                    fontWeight: 700,
                    fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },
                    lineHeight: 1,
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                    mb: { xs: 0.5, sm: 0.5 }
                  }}
                >
                  ${formatCurrency(credit_limit)}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: 'rgba(255, 255, 255, 0.8)',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' }
                  }}
                >
                  Crédito disponible
                </Typography>
              </Box>
            </CardContent>
          </Card>
        </Fade>
      </Grid>
    </Grid>
  );
};

export default BilleteraHeader;